var map = {
	"./1.jpg": 4384,
	"./About": 6284,
	"./About.css": 8765,
	"./About.js": 6284,
	"./AddQuestion": 2246,
	"./AddQuestion.css": 563,
	"./AddQuestion.js": 2246,
	"./AddTest": 6518,
	"./AddTest.css": 8859,
	"./AddTest.js": 6518,
	"./Carousel": 6279,
	"./Carousel.css": 4102,
	"./Carousel.js": 6279,
	"./Exams": 4873,
	"./Exams.css": 4358,
	"./Exams.js": 4873,
	"./LandingPage": 6531,
	"./LandingPage.css": 2874,
	"./LandingPage.js": 6531,
	"./Login": 7584,
	"./Login.css": 9425,
	"./Login.js": 7584,
	"./People": 8342,
	"./People.css": 8557,
	"./People.js": 8342,
	"./Profile": 2296,
	"./Profile.css": 2957,
	"./Profile.js": 2296,
	"./Project Verification - Google Docs.pdf": 2080,
	"./ProjectVerification.pdf": 2003,
	"./Register": 3372,
	"./Register.css": 4571,
	"./Register.js": 3372,
	"./ResultBanner": 5866,
	"./ResultBanner.css": 7977,
	"./ResultBanner.js": 5866,
	"./TestPage": 6302,
	"./TestPage.css": 4773,
	"./TestPage.js": 6302,
	"./Typewriter": 2490,
	"./Typewriter.js": 2490,
	"./Unauthorized": 1931,
	"./Unauthorized.js": 1931,
	"./additional": 9136,
	"./additional.css": 6295,
	"./additional.js": 9136,
	"./back.jpg": 2440,
	"./context/AuthContext": 9192,
	"./context/AuthContext.js": 9192,
	"./exams": 2066,
	"./exams.json": 2066,
	"./images/enjoy.jpg": 3663,
	"./images/img1.jpeg": 9023,
	"./images/img2.jpeg": 1106,
	"./images/img3.jpeg": 8761,
	"./images/img4.jpeg": 9948,
	"./images/img5.jpg": 3718,
	"./images/logo.png": 6533,
	"./images/prof.gif": 9522,
	"./images/register-image.jpg": 575,
	"./images/study.jpg": 5713,
	"./images/yoga.jpg": 4572,
	"./people": 9785,
	"./people.json": 9785,
	"./people_images/Adya.jpg": 2713,
	"./people_images/AnishKumar.jpg": 5465,
	"./people_images/AnshuSingh.jpg": 160,
	"./people_images/AryaMimamsa.jpg": 478,
	"./people_images/AtikNazir.jpg": 3849,
	"./people_images/AvitanshuAdarsh.jpg": 8814,
	"./people_images/BeautyVitika.jpg": 9406,
	"./people_images/BeautyVitika1.jpg": 6689,
	"./people_images/GaurikaMahi.jpg": 759,
	"./people_images/ManojKumar.jpg": 1473,
	"./people_images/NikhilKumar.jpg": 6857,
	"./people_images/Nitya.jpg": 7853,
	"./people_images/PriyanshuKumar.jpg": 8787,
	"./people_images/RahulKumar.jpg": 5961,
	"./people_images/RanjanRaj.jpg": 7095,
	"./people_images/RaunakKumar.jpg": 5432,
	"./people_images/RishiRaj.jpg": 3494,
	"./people_images/SudhirKumar.jpg": 8705,
	"./people_images/SujeetKumar.jpg": 3810,
	"./people_images/UjjawalGoyal.jpg": 6374,
	"./people_images/VikashKumar.jpg": 5584,
	"./people_images/VishalKumar.jpg": 5169,
	"./people_images/man.jpg": 7842,
	"./resources": 5679,
	"./resources.json": 5679,
	"./result.jpg": 4634,
	"./students": 2134,
	"./students.json": 2134,
	"./tempCodeRunnerFile": 8570,
	"./tempCodeRunnerFile.js": 8570,
	"./user_image/Abhiraj Gupta.jpg": 9641,
	"./user_image/Atik Nazir.jpg": 8586,
	"./user_image/Avinesh Goyal.jpg": 7371,
	"./user_image/GaurikaMahi.jpg": 2298,
	"./user_image/Harsh Raj.jpg": 1712,
	"./user_image/Piyush Kumar.jpg": 6401,
	"./user_image/Prince Kumar.jpg": 5416,
	"./user_image/Rishi Raj.jpg": 2083,
	"./user_image/Ujjawal Goyal.jpg": 2773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8720;